import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/cloudECounter/applicantChange';

export function postRelation() {
    return post(`${url}/relation`);
}

export function postProfession() {
    return post(`${url}/profession`);
}

// 取得選單資訊-縣市/鄉鎮
export function getCityInfo() {
    return get(`${url}/cityInfo`);
}

// 取得選單資訊-手機國碼
export function getMobileCodeInfo() {
    return get(`${url}/mobileCodeInfo`);
}
export function postInfo() {
    return post(`${url}/info`);
}
export function postSubmit(data) {
    return post(`${url}/submit`, data, {
        ...options,
        repeatRequestCancel: true,
        closeAlert: true,
    });
}
//取得營業性質資訊
export function postBusinessData() {
    return post(`${url}/businessData`);
}
//取得篩選過的職業代碼
export function postProfessionSub(data) {
    return post(`${url}/professionSub`, data, {
        ...options,
        repeatRequestCancel: true,
    });
}
// 電話驗證
export function submitContact(data) {
    return post(`${url}/submitContact`, data, { 
        ...options, 
        repeatRequestCancel: true,
        closeAlert: true,
    });
}
